__turbopack_context__.v({
  "controls": "page-module__elqWza__controls",
  "filterCounter": "page-module__elqWza__filterCounter",
  "filters": "page-module__elqWza__filters",
  "filtersButton": "page-module__elqWza__filtersButton",
  "filtersButtonWrapper": "page-module__elqWza__filtersButtonWrapper",
  "filtersColumn": "page-module__elqWza__filtersColumn",
  "main": "page-module__elqWza__main",
  "noResultsWrapper": "page-module__elqWza__noResultsWrapper",
  "results": "page-module__elqWza__results",
  "resultsWrapper": "page-module__elqWza__resultsWrapper",
  "searchWrapper": "page-module__elqWza__searchWrapper",
});
